import { useState, type CSSProperties, type ElementType, type ReactNode } from 'react';
import { useInterval } from '@vespaai/hooks';
import { remainingTimeFromNow } from 'app/lib/utils/date';
import { SECOND_IN_MS } from 'app/lib/utils/time';

export function CountDown({
  targetDate,
  as,
  ...props
}: {
  targetDate: number;
  as?: ElementType;
  style?: CSSProperties;
}): ReactNode {
  const [timeLeft, setTimeLeft] = useState(remainingTimeFromNow(targetDate));

  useInterval(() => {
    setTimeLeft(() => remainingTimeFromNow(targetDate));
  }, SECOND_IN_MS);

  const Type = as || 'div';
  return <Type {...props}>{timeLeft}</Type>;
}
